import {IonProgressBar} from "@ionic/react";
import {useAppSelector} from "../../app/hooks";
import {shortCodeLoadingStates} from "./LoginSlice";

export const LoadingShortStateIndicator = () => {
    const isProcessingShortCode = useAppSelector(x => x.loginSlice.shortCodeLoadingState)
    return isProcessingShortCode === shortCodeLoadingStates.loading ? <IonProgressBar type="indeterminate"/> : null
}